<script setup lang="ts">
import $ from 'jquery'
import useJwPlayer from './useJwPlayer'

const { isMobile } = useDevice()
const { JWP_PROJECT_ID } = useConfiguration()

useHead({
  script: [{ src: `https://cdn.jwplayer.com/libraries/${JWP_PROJECT_ID}.js` }]
})

const activeKey = ref('deskripsi')
const { setupJwPlayer, previewThumbnail } = useJwPlayer()

const animateScroll = (value) => {
  const element = $(`#kursus-detail__${value}`)[0]
  const offset = 130
  const offsetTop = element?.offsetTop - offset

  $('html, body').animate(
    {
      scrollTop: offsetTop // Scroll to the top of the page
    },
    1000
  )
}

const handleScroll = () => {
  const sectionElements = $('section') // Adjust the selector to match your section elements

  for (const sectionElement of sectionElements) {
    const scrollPosition = $('body').scrollTop()
    const offset = 130
    const rect = sectionElement.getBoundingClientRect()
    const offsetTop = sectionElement?.offsetTop - offset
    const offsetBottom = offsetTop + rect.height

    if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
      activeKey.value = sectionElement?.id?.split('_').pop()
      break
    }
  }
}

onMounted(() => {
  $('body').on('scroll', handleScroll)
})

onBeforeUnmount(() => {
  $('body').off('scroll', handleScroll)
})

watch(
  () => previewThumbnail.value,
  (newVal) => {
    if (process.client && newVal) {
      setTimeout(() => {
        setupJwPlayer('jwplayercontent')
      }, 1000)
    }
  }
)
</script>

<template>
  <div class="kursus-detail__wrapper">
    <LazyModulesKursusDetailMoleculesBanner
      @preview="previewThumbnail = $event"
    />

    <div class="container flex">
      <LazyModulesKursusDetailMoleculesStickyMobile v-if="isMobile" />
      <LazyModulesKursusDetailMoleculesSticky
        v-else
        @preview="previewThumbnail = $event"
      />
      <div class="kursus-detail__info">
        <nav>
          <a-tabs v-model:active-key="activeKey" @tab-click="animateScroll">
            <a-tab-pane key="deskripsi" tab="Deskripsi" />
            <a-tab-pane key="materi" tab="Materi" />
            <a-tab-pane key="fasilitator" tab="Fasilitator" />
            <a-tab-pane key="ulasan" tab="Ulasan" />
          </a-tabs>
        </nav>

        <LazyModulesKursusDetailMoleculesDeskripsi />
        <LazyModulesKursusDetailMoleculesMateri />
        <LazyModulesKursusDetailMoleculesFasilitator />
        <LazyModulesKursusDetailMoleculesUlasan />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use './styles.scss';
</style>
